export const getFinanceSetting = config => (dispatch, getState, { get }) => {
    const url = config && config.get('financeSettingApi');

    return dispatch(get(url, 'FINANCE_SETTING'));
};
